import React from "react";

export default function Zertifikate() {
  return (
    <section className="bg-dark text-white min-h-screen p-6 md:p-12">
      <h2 className="text-3xl font-bold text-gold mb-6 text-center">Zertifikate & Urkunden</h2>

      {/* Urkundenanzeige */}
      <div className="flex flex-col md:flex-row gap-6 mb-12">
        <div className="flex-1 text-center">
          <h3 className="text-xl font-semibold mb-2">Bachelorurkunde</h3>
          <img
            src="/images/bachelorurkunde.png"
            alt="Bachelorurkunde"
            className="rounded-xl shadow-lg mx-auto max-h-[500px]"
          />
        </div>
        <div className="flex-1 text-center">
          <h3 className="text-xl font-semibold mb-2">Masterurkunde</h3>
          <img
            src="/images/Masterurkunde.png"
            alt="Masterurkunde"
            className="rounded-xl shadow-lg mx-auto max-h-[500px]"
          />
        </div>
      </div>

      {/* Zertifikatskarten */}
      <div className="grid md:grid-cols-2 gap-8">
        {/* SAP BW/4HANA */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            SAP Certified Application Associate – BW/4HANA 
          </h4>
          <p className="text-sm mb-2">
            Qualifikation zur Modellierung von Datenflüssen, LSA++, Datenextraktion und Analyse in SAP BW/4HANA, Schwerpunkte: Data-Warehousing, Query-Design, Reporting, Datenbeschaffung, Datenmodellierung, Visualisierung
            SAP-Programme: SAP Hana Studio, SAP GUI, HANA Modeler, Adminstration Console, BW Modeling
          </p>
          <a
            href="/zertifikate/eZertifikat-BW1.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-sm text-gold underline hover:text-white transition"
          >
           Datenfluss & BusinessObjects Reporting als PDF ansehen
          </a>

          <a
            href="/zertifikate/eZertifikat-BW2.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="block mt-2 text-sm text-gold underline hover:text-white transition"
          >
            Datenmodellierung & BusinessObjects Lumira als PDF ansehen
          </a>
        </div>

        {/* SAP Analytics Cloud */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            SAP Certified – Analytics Cloud (SAC)
          </h4>
          <p className="text-sm mb-2">
            Kenntnisse in Story Design, Datenmodellierung, BI & Planung mit der SAP Analytics Cloud. Schwerpunkt: Self-Service BI, Dashboarding, Cloud Analytics.
          </p>
          <a
            href="/zertifikate/sap_sac.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
        </div>

        {/* SAP IEE2E */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            SAP S/4HANA Cloud – IEE2E Zertifikat
          </h4>
          <p className="text-sm mb-2">
            Einführung in End-to-End-Prozesse in der SAP S/4HANA Cloud. Verständnis für betriebswirtschaftliche Abläufe in Logistik, Finanzen, Beschaffung, Vertrieb.
          </p>
          <a
            href="/zertifikate/sap_iee2e.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
        </div>

        {/* Cisco CCNA */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg flex flex-col gap-2">
          <div className="flex justify-between items-start">
            <div className="flex-1 pr-4">
              <h4 className="text-gold text-lg font-semibold mb-1">
                Cisco CCNA v7 – Introduction to Networks
              </h4>
              <p className="text-sm mb-2">
                Grundlagen der Netzwerktechnik, IP-Adressierung, Switching, Routing, Subnetting, Netzwerkmodelle. Relevanz: IT-Infrastruktur, Netzwerkadministration.
              </p>
              <a
                href="/zertifikate/cisco_ccna.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gold underline hover:text-white transition"
              >
                Zertifikat als PDF ansehen
              </a>
            </div>
            <a
              href="https://www.credly.com/badges/5d324589-fd47-40e5-9854-86dd3d0c7e64/public_url"
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0"
            >
              <img
                src="/badges/ccna_badge.png"
                alt="Cisco CCNA Badge"
                className="h-16 w-auto object-contain hover:scale-105 transition-transform"
              />
            </a>
          </div>
        </div>

        {/* Cisco DevNet */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg flex flex-col gap-2">
          <div className="flex justify-between items-start">
            <div className="flex-1 pr-4">
              <h4 className="text-gold text-lg font-semibold mb-1">
                Cisco Certified DevNet Associate
              </h4>
              <p className="text-sm mb-2">
                DevOps- und Automatisierungskenntnisse für Netzwerktechnik, API-Programmierung, Infrastruktur as Code, Python-Scripting für Netzwerkprozesse.
              </p>
              <a
                href="/zertifikate/cisco_devnet.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gold underline hover:text-white transition"
              >
                Zertifikat als PDF ansehen
              </a>
            </div>
            <a
              href="https://www.credly.com/badges/24754d5f-5a41-46eb-9338-876949d95003/public_url"
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0"
            >
              <img
                src="/badges/devnet_badge.png"
                alt="Cisco DevNet Badge"
                className="h-16 w-auto object-contain hover:scale-105 transition-transform"
              />
            </a>
          </div>
        </div>

        {/* Cisco Cybersecurity Essentials */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg flex flex-col gap-2">
          <div className="flex justify-between items-start">
            <div className="flex-1 pr-4">
              <h4 className="text-gold text-lg font-semibold mb-1">
                Cisco Cybersecurity Essentials
              </h4>
              <p className="text-sm mb-2">
                Einführung in IT-Sicherheit: Bedrohungsmodelle, Sicherheitsrichtlinien, Netzwerksicherheit, Angriffsarten und Verteidigungsmechanismen.
              </p>
              <a
                href="/zertifikate/cisco_cybersecurity.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-gold underline hover:text-white transition"
              >
                Zertifikat als PDF ansehen
              </a>
            </div>
            <a
              href="https://www.credly.com/badges/ab3b70a4-b280-42af-a2b1-fe991f530cd8/public_url"
              target="_blank"
              rel="noopener noreferrer"
              className="shrink-0"
            >
              <img
                src="/badges/cybersecurity_badge.png"
                alt="Cisco Cybersecurity Badge"
                className="h-16 w-auto object-contain hover:scale-105 transition-transform"
              />
            </a>
          </div>
        </div>

        {/* LinkedIn Learning Zertifikate */}
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Data Science lernen: Die Grundlagen verstehen (LinkedIn Learning)
          </h4>
          <p className="text-sm mb-2">
            Einführung in Statistik, Datenquellen, Datenbanken und Data Pipelines. Teil des Lernpfads
            „Grundwissen Datenanalyse“, bereitgestellt von Microsoft & LinkedIn.
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
          <a
            href="/zertifikate/data_science_grundlagen.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
          <a
            href="/zertifikate/data_science_stroytelling.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
          </div>
        </div>

        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Datenanalyse lernen (LinkedIn Learning)
          </h4>
          <p className="text-sm mb-2">
            Power BI, Excel, analytisches Denken und Visualisierung – praxisorientiert und einsteigerfreundlich.
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
          <a
            href="/zertifikate/data_karriere_faehigkeiten.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
          <a
            href="/zertifikate/datananalyse1.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
          <a
            href="/zertifikate/datananalyse2.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
          </div>
        </div>

        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Business English for Professionals (LinkedIn Learning)
          </h4>
          <p className="text-sm mb-2">
            Präsentationen, E-Mail-Kommunikation, Meetings und Verhandlungen auf Englisch – für den professionellen IT- und Beratungskontext.
          </p>
          <div className="flex flex-wrap gap-4 mt-2">
          <a
            href="/zertifikate/business_english_smallTalk.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
          <a
            href="/zertifikate/business_english.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
          </div>
        </div>

        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Root Cause Analysis (LinkedIn Learning)
          </h4>
          <p className="text-sm mb-2">
            Ursachenanalyse mit Methoden wie 5-Why, Ishikawa-Diagrammen und systematischer Problemanalyse.
          </p>
          <a
            href="/zertifikate/root_cause_analysis.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
        </div>

        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
          <h4 className="text-gold text-lg font-semibold mb-1">
            Problem Solving Techniques (LinkedIn Learning)
          </h4>
          <p className="text-sm mb-2">
            Kreative und analytische Methoden zur strukturierten Problemlösung – inkl. Brainstorming, Entscheidungsfindung und Priorisierung.
          </p>
          <a
            href="/zertifikate/problem_solving.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gold underline hover:text-white transition"
          >
            Zertifikat als PDF ansehen
          </a>
        </div>
        <div className="bg-gray-800 p-5 rounded-2xl shadow-lg">
  <h4 className="text-gold text-lg font-semibold mb-1">
    Anerkennung der Sachkenntnis nach § 75 AMG (Pharmaberater)
  </h4>
  <p className="text-sm mb-2">
    Offizielle Anerkennung durch die Bezirksregierung Arnsberg: Mein Bachelorabschluss in Biomedizintechnik wurde gemäß § 75 Abs. 3 Arzneimittelgesetz als gleichwertig mit pharmazeutischen Ausbildungen anerkannt. Damit bin ich befähigt, als Pharmaberater tätig zu sein.
  </p>
  <a
    href="/zertifikate/anerkennung_amg.pdf"
    target="_blank"
    rel="noopener noreferrer"
    className="text-sm text-gold underline hover:text-white transition"
  >
    Anerkennungsbescheid als PDF ansehen
  </a>
  <p className="text-xs italic text-gray-400 mt-1">Ausgestellt: September 2022</p>
</div>

      </div>
    </section>
  );
}
